import React from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { Oval } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { forgotPassword, resetForgotPassword } from "../authSlice";

export interface ForgotPasswordFormModel {
  email: string;
}

const initialValues: ForgotPasswordFormModel = {
  email: "",
};

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

export function ForgotPasswordForm() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isLoading = useAppSelector(
    (state) => state.auth.forgotPassword.loading
  );
  const error = useAppSelector((state) => state.auth.forgotPassword.error);
  const forgotPasswordSuccess = useAppSelector(
    (state) => !!state.auth.forgotPassword.value
  );

  React.useEffect(() => {
    if (!isLoading && !!error) {
      toast.error("Something went wrong. Please try again.");
    }

    if (!isLoading && !error && forgotPasswordSuccess) {
      toast.success("Password reset email sent. Please check your inbox.");
      dispatch(resetForgotPassword());
      navigate("/auth/login");
    }
  }, [forgotPasswordSuccess, error]);

  const onSubmit = (form: ForgotPasswordFormModel) => {
    dispatch(forgotPassword(form.email));
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ errors, touched }) => (
        <Form className="register-account-form-component">
          <div className="form-field-container">
            <Field
              id="email"
              name="email"
              placeholder="Email"
              className="form-field-text"
            />
            {errors.email && touched.email && (
              <div className="form-error">{errors.email}</div>
            )}
          </div>

          <div className="button-container">
            <button type="submit" className="login-button" disabled={isLoading}>
              Send Reset Email
              {isLoading && (
                <div style={{ marginLeft: 8 }}>
                  <Oval
                    color="#131313"
                    height={20}
                    width={20}
                    secondaryColor="#FBD20A"
                  />
                </div>
              )}
            </button>

            {!!error && (
              <div className="error-text">
                Something went wrong. Please try again.
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}
